import React from 'react'
import Layout from 'templates/ModuleTemplate'
import ModuleGuard from 'components/ModuleGuard'
import { CorbanProvider } from '../Context'

const CorbanLayout: React.FC = ({ children }) => {
  return (
    <Layout>
      <ModuleGuard>
        <CorbanProvider>{children}</CorbanProvider>
      </ModuleGuard>
    </Layout>
  )
}

export default CorbanLayout
